import { useRef } from 'react';
import { CommonPortalProvider } from '../../contexts/commonPortal';
import { IPopup } from '../../constants/commonPortal.constant';

const CommonPortalController = (props) => {
  const {
    component: Component,
  } = props;

  const snackbar = useRef({});
  const fsPopup = useRef({});

  const handleSnackbarClose = () => {
    snackbar.current.handleSnackbarClose();
  };

  const handleSnackbarOpen = (_propup = IPopup({})) => {
    snackbar.current.handleSnackbarOpen(_propup);
  };

  const handleFSPopupClose = () => {
    fsPopup.current.handleFSPopupClose();
  };

  const handleFSPopupOpen = (_propup = IPopup({})) => {
    fsPopup.current.handleFSPopupOpen(_propup);
  };

  return (
    <CommonPortalProvider
      value={{
        ref: {
          snackbar,
          fsPopup,
        },

        handler: {
          handleSnackbarClose,
          handleSnackbarOpen,
          handleFSPopupClose,
          handleFSPopupOpen,
        },
      }}
    >
      <Component {...props} />
    </CommonPortalProvider>
  );
};

export const CommonPortalControllerHOC = (Component) => (props) => (
  <CommonPortalController component={Component} {...props} />
);

export default CommonPortalControllerHOC;
